import type { OfferData, OfferStatus } from 'service/offer/model';
import { localize } from 'i18n/localize.ts';

const $t = localize();

type Props = {
	offer: OfferData;
};

const INACTIVE_STATUSES: OfferStatus[] = ['inactive', 'disabled'];

export function isInactive(offerStatus: OfferStatus): boolean {
	return INACTIVE_STATUSES.includes(offerStatus);
}

export function OfferStatusAsText({ offer }: Props) {
	const isOfferInactive = isInactive(offer.status);

	if (!isOfferInactive) return $t.offer.published;
	if (offer.approvalAdmin === 'rejected') return $t.offer.rejected;
	if (offer.sold === 'sold_other') return $t.offer.withdrawOptions.soldElsewhere;
	if (offer.sold === 'sold_sbazar') return $t.offer.withdrawOptions.soldOnSbazar;
	if (offer.sold === 'not_specified') return $t.offer.withdrawOptions.soldNoInfo;

	return $t.offer.hidden;
}
